"use client"

import { AlertCircle } from "lucide-react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface OrphanRecoveryBannerProps {
  onGenerateResponse: () => void
  onDismiss: () => void
  isGenerating?: boolean
  className?: string
}

export function OrphanRecoveryBanner({
  onGenerateResponse,
  onDismiss,
  isGenerating,
  className,
}: OrphanRecoveryBannerProps) {
  return (
    <div
      className={cn(
        "sticky top-0 z-50 w-full border-b border-amber-500/30 bg-amber-500/10 backdrop-blur-sm",
        className,
      )}
    >
      <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <AlertCircle className="h-5 w-5 text-amber-600 dark:text-amber-400 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground">Your message is waiting for a response</p>
            <p className="text-xs text-muted-foreground">
              The assistant reply didn't complete. Click to generate it now.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            onClick={onGenerateResponse}
            disabled={isGenerating}
            size="sm"
            className="bg-[var(--cta)] hover:bg-[var(--cta)]/90 text-white"
          >
            {isGenerating ? "Generating..." : "Generate response"}
          </Button>
          <button
            onClick={onDismiss}
            disabled={isGenerating}
            className="text-muted-foreground hover:text-foreground p-2 rounded-md hover:bg-surface transition-colors"
            aria-label="Dismiss"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
